import { render, staticRenderFns } from "./email-actions-list.vue?vue&type=template&id=02bd2bc0&"
import script from "./email-actions-list.vue?vue&type=script&lang=js&"
export * from "./email-actions-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports